import { FilterChips } from 'cdk-radial';
import styled from 'styled-components';

export const StyledPaymentMethodDiv = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledPaymentMethodLabelSpan = styled.span`
  margin: 0px 10px 0 20px;
`;

export const StyledFilterChips = styled(FilterChips)`
  padding-top: 5px;
  svg {
    ${props =>
      props.$isNeedsAuthorization
        ? {
            border: '1px solid rgba(21, 27, 37, 0.25)',
            borderRadius: '50%',
            left: '10px'
          }
        : {
            border: '1px solid rgba(21, 27, 37, 0.25)',
            left: '10px'
          }}
})
  
`;
